import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireHelmet } from '../node_modules/react-helmet/lib/Helmet.js';

var HelmetExports = requireHelmet();
var Helmet = /*@__PURE__*/getDefaultExportFromCjs(HelmetExports);

export { Helmet as default };
